import { NAME } from './constants';

export const getFlight = state => state[NAME];



// WEBPACK FOOTER //
// ./modules/SingleFlight/redux/selectors.js